<script setup>
import { faCheck, faXmark } from '@fortawesome/pro-regular-svg-icons'

defineProps({
  state: {
    type: String,
    default: null,
    validator: (value) => value === null || ['pending', 'completed', 'failed'].includes(value),
  },
})
</script>

<template>
  <span v-if="state === 'pending'" class="spinner-border spinner-border-sm tw:text-primary" data-cy="bank-pull-status-icon" />
  <font-awesome-icon v-else-if="state === 'completed'" :icon="faCheck" class="green-300" data-cy="bank-pull-status-icon" />
  <font-awesome-icon v-else-if="state === 'failed'" :icon="faXmark" class="red-300" data-cy="bank-pull-status-icon" />
</template>
